/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_medicalInstitution_requestGetCareOfficeByCode } from '../models/api_medicalInstitution_requestGetCareOfficeByCode';
import type { api_medicalInstitution_requestGetHospitalByCode } from '../models/api_medicalInstitution_requestGetHospitalByCode';
import type { api_medicalInstitution_requestGetNurseStationByCode } from '../models/api_medicalInstitution_requestGetNurseStationByCode';
import type { api_medicalInstitution_requestSearchCareOfficesByName } from '../models/api_medicalInstitution_requestSearchCareOfficesByName';
import type { api_medicalInstitution_requestSearchHospitalsByName } from '../models/api_medicalInstitution_requestSearchHospitalsByName';
import type { api_medicalInstitution_requestSearchNurseStationsByName } from '../models/api_medicalInstitution_requestSearchNurseStationsByName';
import type { api_medicalInstitution_responseGetCareOfficeByCode } from '../models/api_medicalInstitution_responseGetCareOfficeByCode';
import type { api_medicalInstitution_responseGetHospitalByCode } from '../models/api_medicalInstitution_responseGetHospitalByCode';
import type { api_medicalInstitution_responseGetNurseStationByCode } from '../models/api_medicalInstitution_responseGetNurseStationByCode';
import type { api_medicalInstitution_responseSearchCareOfficesByName } from '../models/api_medicalInstitution_responseSearchCareOfficesByName';
import type { api_medicalInstitution_responseSearchHospitalsByName } from '../models/api_medicalInstitution_responseSearchHospitalsByName';
import type { api_medicalInstitution_responseSearchNurseStationsByName } from '../models/api_medicalInstitution_responseSearchNurseStationsByName';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MedicalInstitutionService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get CareOffice By Code
     * 介護事業所を介護保険事業所コードで完全一致検索する
     * @returns api_medicalInstitution_responseGetCareOfficeByCode responseGetCareOfficeByCode
     * @throws ApiError
     */
    public postMedicalInstitutionGetCareOfficeByCode({
        body,
    }: {
        /**
         * requestGetCareOfficeByCode
         */
        body: api_medicalInstitution_requestGetCareOfficeByCode,
    }): CancelablePromise<api_medicalInstitution_responseGetCareOfficeByCode> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/medical_institution/get_care_office_by_code',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Hospital By Code
     * まろんAPIを実行し、病院を医療機関コードで完全一致検索する
     * @returns api_medicalInstitution_responseGetHospitalByCode responseGetHospitalByCode
     * @throws ApiError
     */
    public postMedicalInstitutionGetHospitalByCode({
        body,
    }: {
        /**
         * requestGetHospitalByCode
         */
        body: api_medicalInstitution_requestGetHospitalByCode,
    }): CancelablePromise<api_medicalInstitution_responseGetHospitalByCode> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/medical_institution/get_hospital_by_code',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get NurseStation By Code
     * 看護ステーションを医療機関コードで完全一致検索する
     * @returns api_medicalInstitution_responseGetNurseStationByCode responseGetNurseStationByCode
     * @throws ApiError
     */
    public postMedicalInstitutionGetNurseStationByCode({
        body,
    }: {
        /**
         * requestGetNurseStationByCode
         */
        body: api_medicalInstitution_requestGetNurseStationByCode,
    }): CancelablePromise<api_medicalInstitution_responseGetNurseStationByCode> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/medical_institution/get_nurse_station_by_code',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Search CareOffices By Name
     * 介護事業所を名前で部分一致検索する
     * @returns api_medicalInstitution_responseSearchCareOfficesByName responseSearchCareOfficesByName
     * @throws ApiError
     */
    public postMedicalInstitutionSearchCareOfficesByName({
        body,
    }: {
        /**
         * requestSearchCareOfficesByName
         */
        body: api_medicalInstitution_requestSearchCareOfficesByName,
    }): CancelablePromise<api_medicalInstitution_responseSearchCareOfficesByName> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/medical_institution/search_care_offices_by_name',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Search Hospitals By Name
     * まろんAPIを実行し、病院を医療機関名で部分一致検索する
     * @returns api_medicalInstitution_responseSearchHospitalsByName responseSearchHospitalsByName
     * @throws ApiError
     */
    public postMedicalInstitutionSearchHospitalsByName({
        body,
    }: {
        /**
         * requestSearchHospitalsByName
         */
        body: api_medicalInstitution_requestSearchHospitalsByName,
    }): CancelablePromise<api_medicalInstitution_responseSearchHospitalsByName> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/medical_institution/search_hospitals_by_name',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Search NurseStations By Name
     * 看護ステーションを名前で部分一致検索する
     * @returns api_medicalInstitution_responseSearchNurseStationsByName responseSearchNurseStationsByName
     * @throws ApiError
     */
    public postMedicalInstitutionSearchNurseStationsByName({
        body,
    }: {
        /**
         * requestSearchNurseStationsByName
         */
        body: api_medicalInstitution_requestSearchNurseStationsByName,
    }): CancelablePromise<api_medicalInstitution_responseSearchNurseStationsByName> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/medical_institution/search_nurse_stations_by_name',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
